import React, { useState } from 'react';
import { Button, Card, Form, Input, message, Typography, Alert } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { api } from '../../http/API';

const { Title, Paragraph } = Typography;

const ForgotPasswordPage: React.FC = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState<string | null>(null);
    const [email, setEmail] = useState('');

    const onFinish = async (values: { email: string }) => {
        setLoading(true);
        try {
            await api.ForgotPassword(values.email);
            setSubmitted(values.email);
        } catch (error: any) {
            // 429 = антиспам на backend. Показываем мягкое сообщение.
            if (error?.response?.status === 429) {
                message.warning('Код уже отправлен. Подождите минуту перед повторной отправкой.');
            } else {
                // Не раскрываем, есть ли email — показываем нейтральное сообщение.
                setSubmitted(values.email);
            }
        } finally {
            setLoading(false);
        }
    };

    const goToReset = () => {
        navigate('/reset-password', { state: { email: submitted } });
    };

    const resetEmail = () => {
        setSubmitted(null);
        setEmail('');
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f0f2f5' }}>
            <Card style={{ width: 400, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                <Title level={3} style={{ textAlign: 'center' }}>Восстановление пароля</Title>

                {submitted ? (
                    <>
                        <Alert
                            type="info"
                            showIcon
                            style={{ marginBottom: 16 }}
                            message="Проверьте почту"
                            description={
                                <>
                                    Если <strong>{submitted}</strong> зарегистрирован в системе,
                                    мы отправили на него 6-значный код. Письмо может прийти
                                    в течение пары минут — проверьте папку «Спам».
                                </>
                            }
                        />
                        <Button type="primary" block onClick={goToReset} style={{ marginBottom: 8 }}>
                            Ввести код
                        </Button>
                        <Button block onClick={resetEmail}>
                            Изменить email
                        </Button>
                    </>
                ) : (
                    <>
                        <Paragraph type="secondary" style={{ textAlign: 'center' }}>
                            Укажите email, привязанный к вашему аккаунту. Мы отправим код для сброса пароля.
                        </Paragraph>
                        <Form layout="vertical" onFinish={onFinish}>
                            <Form.Item
                                label="Email"
                                name="email"
                                rules={[
                                    { required: true, message: 'Введите email' },
                                    { type: 'email', message: 'Некорректный email' },
                                ]}
                            >
                                <Input
                                    prefix={<MailOutlined />}
                                    placeholder="Ваш email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </Form.Item>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" block loading={loading}>
                                    Отправить код
                                </Button>
                            </Form.Item>
                            <div style={{ textAlign: 'center' }}>
                                <Button type="link" onClick={() => navigate('/login')}>
                                    Вернуться ко входу
                                </Button>
                            </div>
                        </Form>
                    </>
                )}
            </Card>
        </div>
    );
};

export default ForgotPasswordPage;
